export default __webpack_public_path__ + "static/adam-nazar-de18c404d9b0721391181d05476010a4.png";